import EntitiesRoutes from 'app/entities/routes';
import React from 'react';
import { Route } from 'react-router-dom';
import { AUTHORITIES } from './config/constants';
import Account from './modules/account';
import PasswordResetFinish from './modules/account/password-reset/finish/password-reset-finish';
import PasswordResetInit from './modules/account/password-reset/init/reset-password';
import Register from './modules/account/register/register';
import Home from './modules/home/home';
import Login from './modules/login/login';
import Logout from './modules/login/logout';
import PrivateRoute from './shared/auth/private-route';
import ErrorBoundaryRoutes from './shared/error/error-boundary-routes';
import PageNotFound from './shared/error/page-not-found';

const AppRoutes = () => {
  return (
    <div className="view-routes">
      <ErrorBoundaryRoutes>
        <Route
          path="/"
          index
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route index path="/login" element={<Login />} />
        <Route path="logout" element={<Logout />} />
        <Route path="account">
          <Route
            path="*"
            element={
              <Account />
            }
          />
          <Route path="register" element={<Register />} />
          <Route path="reset">
            <Route path="request" element={<PasswordResetInit />} />
            <Route path="finish" element={<PasswordResetFinish />} />
          </Route>
        </Route>
        <Route
          path="*"
          element={
            <PrivateRoute hasAnyAuthorities={[AUTHORITIES.USER]}>
              <EntitiesRoutes />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default AppRoutes;
